import { ClearLogFromReports, ContactLinksLoadStart, ReportsLoadStart } from '@/store/reports/actions';
import { goBack as GoBack, push as Push } from 'redux-first-history';

import { ContactsPaths } from '@/services/dictionaries/Paths';
import { GetContactFieldsStart } from '@/store/customFields/actions';
import { ListLoadByContactStart } from '@/store/lists/actions';
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { SegmentLoadByContactStart } from '@/store/segments/actions';
import { ShowDialog } from '@/store/dialog/actions';
import { SingleContact as SingleContactModule } from '@dev/ee-modules';
import { ApplicationState as State } from '@/store';
import { ViewEmailStart } from '@/store/emails/actions';
import { compose } from 'react-recompose';
import { connect } from 'react-redux';
import dayjs from '@/services/tools/dayjs';
import { withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';
import { ContactProps, DispatchProps, Props, StateToProps } from './ContactInterface';
import {
    ContactDeselect,
    ContactGetHistoryStart,
    ContactUpdateStart,
    SingleContactStartLoading,
} from '../../../store/contacts/actions';

const dispatchProps = {
    SingleContactStartLoading,
    ReportsLoadStart,
    SegmentLoadByContactStart,
    ListLoadByContactStart,
    ContactLinksLoadStart,
    ContactGetHistoryStart,
    ContactUpdateStart,
    ViewEmailStart,
    ShowDialog,
    ContactDeselect,
    Push,
    GetContactFieldsStart,
    GoBack,
    ClearLogFromReports,
};

const mapState = (state: State, ownProps: ContactProps): ContactProps & StateToProps => ({
    ...ownProps,
    account: state.account,
    isLoading: state.contacts.isContactsLoading,
    selected: state.contacts.selectedContact,
    reports: state.reports,
    segments: state.segments,
    lists: state.lists,
    contacts: state.contacts,
    isContactHistoryLoading: state.contacts.isContactHistoryLoading,
    customFields: state.customFields,
    config: state.config,
});

class SingleContact extends React.Component<Props> {
    public render(): JSX.Element {
        return (
            <SingleContactModule
                dayjs={dayjs}
                paths={ContactsPaths}
                {...(this.props as any)}
                GetContactFieldsStart={() => GetContactFieldsStart({ isUrlUpdateDisabled: true })}
            />
        );
    }
}

export default compose(
    withRouter,
    withTranslation(),
    connect<StateToProps, DispatchProps, ContactProps>(mapState, dispatchProps)
)(SingleContact);
